import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
import { db } from '../../db/db-dexie'
const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }

const AccountService = {
    async Get() { return await methods.Get("Account/Get"); },
    async FormaPagoGet() { return await methods.Get("Account/FormaPagoGet"); },
    async ByentityGet(qs) { return await methods.Get("Account/Get" + useParamsJson(qs)); },
    async Migrar(qs) { return await methods.Get("Account/Migrar" + useParamsJson(qs)); },
    async List() {
        const result = await AccountService.Get();
        if (result && result.code === '1' && result.payload) {
            const data = JSON.parse(result.payload);
            await db.transaction('rw', db.account, async () => {
                await db.account.clear();
                if (Array.isArray(data) && data.length > 0) {
                    await db.account.bulkPut(data);
                }
            });
            return true;
        } else if (result && result.code === '0') {
            await db.account.clear();
            return true;
        }
        return false;
    }


};

export default AccountService;